module.exports = __webpack_public_path__ + "static/media/detail5.c76d1f2b.svg";